import React, { useState, memo, useEffect } from "react";
import Wrappers from "../shared/Wrappers";
import HeaderBreadcrumb from "../shared/HeaderBreadcrumb";
import CustomerDetailsFilter from "./CustomerDetailsFilter";
import DetailForm from "./DetailForm";
import CustomerOrders from "./CustomerOrders";
import { useParams } from "react-router-dom";
import { GetCustomerByID } from "../../../services/admin/customer";
import Loader from "../../shared/loader";

const CustomerDetails = () => {
  const { id } = useParams();
  const [activeBtn, SetactiveBtn] = useState(0);
  const FilterButton = ["Customer Details", "Customer Orders"];
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState([]);
  const CustomerName = AllData?.data?.user?.name || "customer name";
  const customerHeader = ["customers", CustomerName, "customer details"];
  const orderHeader = ["customers", CustomerName, "customer orders"];
  const [CurrentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getSingleCustomer();
  }, [id, CurrentPage]);

  const getSingleCustomer = async () => {
    const Page = CurrentPage || 1;
    await GetCustomerByID(setLoading, setAllData, id, Page);
  };

  return (
    <Wrappers>
      {loading && <Loader />}

      {!loading && (
        <>
          {activeBtn === 0 && (
            <HeaderBreadcrumb
              ItemsName={customerHeader}
              GoTo="/admin/customers"
            />
          )}
          {activeBtn === 1 && (
            <HeaderBreadcrumb ItemsName={orderHeader} GoTo="/admin/customers" />
          )}

          <CustomerDetailsFilter
            FilterButton={FilterButton}
            clickHandler={SetactiveBtn}
            activeBtn={activeBtn}
            setCurrentPage={setCurrentPage}
            CurrentPage={CurrentPage}
          />
          {activeBtn === 0 && <DetailForm AllData={AllData} />}
          {activeBtn === 1 && (
            <CustomerOrders
              AllData={AllData}
              CurrentPage={CurrentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </>
      )}
    </Wrappers>
  );
};

export default memo(CustomerDetails);
